function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import { CurrencyInput, Input } from "../../helperComponents/";
import { CurrencyTypes } from "../../utils/data";
import { formatValue } from "../../utils/currency";
import General from "./ramo/General";
import LightVehicles from "./ramo/LightVehicles";
import HeavyVehicles from "./ramo/HeavyVehicles";
import HomeFire from "./ramo/HomeFire";

var ItemAseguradoForm = function ItemAseguradoForm(props) {
  var poliza = props.poliza,
      _onChange = props.onChange,
      onChangeToStep = props.onChangeToStep,
      regions = props.regions,
      comunas = props.comunas,
      itemAsegurado = props.itemAsegurado,
      index = props.index;

  var handleIsComercialValue = function handleIsComercialValue() {
    var is_comercial_value = itemAsegurado.is_comercial_value;
    var newIsComercialValue = !is_comercial_value;
    var changes = newIsComercialValue ? {
      is_comercial_value: newIsComercialValue
    } : {
      is_comercial_value: newIsComercialValue,
      asegurado_amount: 0
    };
    return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), changes));
  };

  var renderItemByRamo = function renderItemByRamo() {
    switch (poliza.ramo) {
      case "VEH. LIVIANOS":
        return /*#__PURE__*/React.createElement(LightVehicles, {
          onChange: _onChange,
          itemAsegurado: itemAsegurado,
          index: index
        });

      case "VEH. PESADOS":
        return /*#__PURE__*/React.createElement(HeavyVehicles, {
          onChange: _onChange,
          itemAsegurado: itemAsegurado,
          index: index
        });

      case "INC. HOGAR":
        return /*#__PURE__*/React.createElement(HomeFire, {
          index: index,
          itemAsegurado: itemAsegurado,
          onChange: _onChange,
          listRegions: regions,
          listCommunes: comunas
        });

      default:
        return /*#__PURE__*/React.createElement(General, {
          itemAsegurado: itemAsegurado,
          onChange: _onChange
        });
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid cntItemAseguradoForm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, poliza.ramo ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Item Asegurado:"), "  ", " ", poliza.ramo, " ", "  ", /*#__PURE__*/React.createElement("a", {
    onClick: function onClick() {
      return onChangeToStep && onChangeToStep(1);
    }
  }, "Cambiar")) : /*#__PURE__*/React.createElement("strong", null, "Item Asegurado")), renderItemByRamo())), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 cntDatosGenerales"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/React.createElement("strong", null, "Datos Generales")), /*#__PURE__*/React.createElement("div", {
    className: "card-body cardBody"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5 checkbox addMarginBottom cntIsComercialValue"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.is_comercial_value,
    onChange: handleIsComercialValue
  }), "\xBFValor Comercial?")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 cntAseguradoAmount"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Monto Asegurado"), itemAsegurado !== null && itemAsegurado !== void 0 && itemAsegurado.is_comercial_value ? /*#__PURE__*/React.createElement(Input, {
    value: "VC",
    classNameInput: "form-control",
    disabled: true
  }) : /*#__PURE__*/React.createElement(CurrencyInput, {
    currency: CurrencyTypes.UF,
    className: "form-control addMarginBottom",
    defaultValue: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.asegurado_amount,
    disabled: itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.is_comercial_value,
    onValueChange: function onValueChange(value) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        asegurado_amount: formatValue(value, 3)
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 addMarginBottom"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Comentarios Opcionales"), /*#__PURE__*/React.createElement("textarea", {
    className: "form-control",
    rows: 3,
    value: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.comments) || "",
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        comments: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 addMarginBottom"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Minuta Interna"), /*#__PURE__*/React.createElement("textarea", {
    className: "form-control",
    rows: 3,
    value: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.draft) || "",
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        draft: event.target.value
      }));
    }
  })))))));
};

export default ItemAseguradoForm;